var map = {
	"./web-P4-0.png": "293e",
	"./web-P4-1.png": "d647",
	"./web-P4-2-1.png": "2181",
	"./web-P4-2-2.png": "f25e",
	"./web-P4-2.png": "0653",
	"./web-P4-3-1.png": "36f3",
	"./web-P4-3-4.png": "254f",
	"./web-P4-3.png": "411e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "193d";